import { HubCookie } from '../../common/utils/HubCookie';

const HubCookieInit = (element) => {
    window.hubCookie = new HubCookie();
};

export { HubCookieInit };


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Cookie/index.js